import { z } from 'zod';

export const createEmotionLogSchema = z.object({
  emotion_type: z.enum(
    ['fear', 'greed', 'confidence', 'anxiety', 'calm', 'anger', 'excitement'],
    { message: '请选择情绪类型' }
  ),
  intensity: z.number().min(1, '强度最小为1').max(10, '强度最大为10'),
  trigger: z
    .enum([
      'consecutive_loss',
      'consecutive_profit',
      'see_opportunity',
      'holding_pressure',
      'market_volatility',
      'other',
    ])
    .optional(),
  context: z.enum(['before_trade', 'during_trade', 'after_trade', 'general'], {
    message: '请选择情境',
  }),
  trade_id: z.number().positive().optional(),
  notes: z.string().max(500, '备注最多500个字符').optional(),
});

export const emotionFilterSchema = z.object({
  emotion_type: z
    .enum(['fear', 'greed', 'confidence', 'anxiety', 'calm', 'anger', 'excitement'])
    .optional(),
  context: z.enum(['before_trade', 'during_trade', 'after_trade', 'general']).optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  min_intensity: z.number().min(1).max(10).optional(),
  max_intensity: z.number().min(1).max(10).optional(),
});

export type CreateEmotionLogFormData = z.infer<typeof createEmotionLogSchema>;
export type EmotionFilterFormData = z.infer<typeof emotionFilterSchema>;
